import * as fromCharts from "../actions/chart.actions";
import { KpiBaseChartDto, KpiDynamicChartDto } from "../../services";

export const FEATURE_KEY = "charts";

export interface ChartState {
  entities: { [id: string]: KpiBaseChartDto };
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export const initialState: ChartState = {
  entities: {},
  loading: false,
  loaded: false,
  error: false,
};

export function reducer(state = initialState, action: fromCharts.ChartsActions): ChartState {
  switch (action.type) {
    case fromCharts.LOAD_STATIC_CHART:
    case fromCharts.DELETE_CHART:
    case fromCharts.UPDATE_CHART:
    case fromCharts.CREATE_CHART:
    case fromCharts.LOAD_CHARTS: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case fromCharts.LOAD_CHARTS_SUCCESS: {
      const alerts = action.payload;
      const entities = alerts.reduce(
        (entities: { [id: string]: KpiDynamicChartDto }, chart: KpiDynamicChartDto) => {
          return {
            ...entities,
            [chart.id]: chart,
          };
        },
        {
          ...state.entities,
        },
      );
      return {
        ...state,
        loading: false,
        loaded: true,
        entities,
      };
    }
    case fromCharts.LOAD_STATIC_CHART_SUCCESS:
    case fromCharts.UPDATE_CHART_SUCCESS:
    case fromCharts.CREATE_CHART_SUCCESS: {
      const chart = action.payload;
      const entities = {
        ...state.entities,
        [chart.id]: chart,
      };
      return {
        ...state,
        entities,
        loading: false,
        loaded: true,
      };
    }
    case fromCharts.DELETE_CHART_SUCCESS: {
      const chartId = action.id;
      const { [chartId]: removed, ...entities } = state.entities;
      return {
        ...state,
        entities,
      };
    }
    case fromCharts.REORDER_CHARTS: {
      const charts = action.payload;
      const entities = { ...state.entities };
      charts.forEach((chart) => {
        entities[chart.id] = chart;
      });
      return {
        ...state,
        entities,
      };
    }

    case fromCharts.LOAD_STATIC_CHART_FAIL:
    case fromCharts.DELETE_CHART_FAIL:
    case fromCharts.UPDATE_CHART_FAIL:
    case fromCharts.CREATE_CHART_FAIL:
    case fromCharts.LOAD_CHARTS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
  }
  return state;
}

export const getChartEntities = (state: ChartState) => state.entities;
export const getChartsLoading = (state: ChartState) => state.loading;
export const getChartsLoaded = (state: ChartState) => state.loaded;
